import { createSlice } from '@reduxjs/toolkit'

export const attributeSelectionSlice = createSlice({
    name: 'attributeSelection',
    initialState: {
        result: undefined,
    },
    reducers: {
        setAttributeSelectionRedux: (state, action) => {
            state.result = action.payload;
        },
    },
})

export const { setAttributeSelectionRedux } = attributeSelectionSlice.actions;

export const getAttributeSelection = (state) => state.attributeSelection.result;

export default attributeSelectionSlice.reducer